(function () {
  const formatMoney = (cents, format) => {
    if (format == null || format === '') format = '£{{amount}}';
    if (typeof cents === 'string') cents = cents.replace(/[^0-9-]/g, '');
    const value = (Number(cents) / 100).toFixed(2);
    const parts = value.split('.');
    const amountNoDecimals = parts[0];
    const amountWithCommaSeparators = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const amountWithApostropheSeparators = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    const amountWithSpaceSeparators = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const amountWithPeriodSeparators = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    const map = {
      amount: value,
      amount_no_decimals: amountNoDecimals,
      amount_with_comma_separator: amountWithCommaSeparators + '.' + (parts[1] || '00'),
      amount_no_decimals_with_comma_separator: amountWithCommaSeparators,
      amount_with_apostrophe_separator: amountWithApostropheSeparators + '.' + (parts[1] || '00'),
      amount_no_decimals_with_space_separator: amountWithSpaceSeparators,
      amount_with_space_separator: amountWithSpaceSeparators + ',' + (parts[1] || '00'),
      amount_with_period_and_space_separator: amountWithSpaceSeparators + '.' + (parts[1] || '00'),
      amount_with_period_separator: amountWithPeriodSeparators + ',' + (parts[1] || '00')
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => (map[key] != null ? map[key] : value));
  };

  const initAccordions = (root) => {
    root.querySelectorAll('details.amure-pdp__accordion').forEach((item) => {
      if (item.dataset.accordionBound === 'true') return;
      item.dataset.accordionBound = 'true';
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        root.querySelectorAll('details.amure-pdp__accordion[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  };

  const initTabs = (root) => {
    root.querySelectorAll('[data-amure-tabs]').forEach((tabs) => {
      if (tabs.dataset.tabsBound === 'true') return;
      tabs.dataset.tabsBound = 'true';
      const buttons = Array.from(tabs.querySelectorAll('[role="tab"]'));
      if (!buttons.length) return;

      const activate = (name) => {
        buttons.forEach((button) => {
          const selected = button.getAttribute('data-amure-tab') === name;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-selected', selected ? 'true' : 'false');
          button.tabIndex = selected ? 0 : -1;
        });
        tabs.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
          const isMatch = panel.id.indexOf('AmureTab-' + name + '-') === 0;
          panel.classList.toggle('is-active', isMatch);
          if (isMatch) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      };

      buttons.forEach((button, index) => {
        button.tabIndex = button.classList.contains('is-active') ? 0 : -1;
        button.addEventListener('click', () => activate(button.getAttribute('data-amure-tab')));
        button.addEventListener('keydown', (event) => {
          if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) === -1) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          buttons[next].focus();
          activate(buttons[next].getAttribute('data-amure-tab'));
        });
      });
    });
  };

  const initBuyNow = (root) => {
    root.querySelectorAll('[data-amure-buy-now]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const form = document.getElementById(button.getAttribute('data-form'));
        if (!form) return;
        const formData = new FormData(form);
        button.disabled = true;
        fetch(typeof routes !== 'undefined' ? routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              button.disabled = false;
              return;
            }
            window.location.href = '/checkout';
          })
          .catch(() => {
            button.disabled = false;
          });
      });
    });
  };

  const initQtyTotalPrice = (root) => {
    if (root.dataset.qtyPriceBound === 'true') return;
    const qtyInput = root.querySelector('.quantity__input');
    const priceHost = root.querySelector('[id^="price-"]');
    if (!qtyInput || !priceHost) return;

    root.dataset.qtyPriceBound = 'true';
    const moneyFormat = root.getAttribute('data-money-format') || '£{{amount}} GBP';

    const updateTotalPrice = () => {
      const priceEl = priceHost.querySelector('.price');
      if (!priceEl) return;

      const unit = parseInt(priceEl.getAttribute('data-amure-unit-price') || '0', 10);
      const compareAt = parseInt(priceEl.getAttribute('data-amure-compare-at') || '0', 10);
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (!unit) return;

      const total = formatMoney(unit * qty, moneyFormat);
      const compareTotal = compareAt > unit ? formatMoney(compareAt * qty, moneyFormat) : '';

      const salePrice = priceHost.querySelector('.price__sale .price-item--sale');
      const saleCompare = priceHost.querySelector('.price__sale s.price-item--regular');
      const regularPrice = priceHost.querySelector('.price__regular .price-item--regular');

      if (salePrice) {
        salePrice.textContent = total;
        if (saleCompare && compareTotal) saleCompare.textContent = compareTotal;
      } else if (regularPrice) {
        regularPrice.textContent = total;
      }
    };

    qtyInput.addEventListener('change', updateTotalPrice);
    qtyInput.addEventListener('input', updateTotalPrice);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        requestAnimationFrame(updateTotalPrice);
      });
    }

    updateTotalPrice();
  };

  const init = () => {
    document.querySelectorAll('product-info.amure-pdp').forEach((root) => {
      initAccordions(root);
      initBuyNow(root);
      initQtyTotalPrice(root);
    });
    initTabs(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
